import { useEffect } from "react";
import { CONTACT } from "@/data/content";

const setMeta = (name, content, attr = "name") => {
  let el = document.head.querySelector(`meta[${attr}="${name}"]`);
  if (!el) { el = document.createElement("meta"); el.setAttribute(attr, name); document.head.appendChild(el); }
  el.setAttribute("content", content);
};

export const Seo = ({ title, description, schema }) => {
  useEffect(() => {
    document.title = title;
    setMeta("description", description);
    setMeta("og:title", title, "property");
    setMeta("og:description", description, "property");
    setMeta("og:type", "website", "property");

    const ld = {
      "@context": "https://schema.org",
      "@type": "HVACBusiness",
      name: "Genuine Forge",
      description: "Engineering-driven HVAC service and installation for residential and light commercial systems in Chicago.",
      telephone: CONTACT.phone,
      email: CONTACT.email,
      areaServed: "Chicago, IL and surrounding ~20-mile radius",
      address: { "@type": "PostalAddress", addressLocality: "Chicago", addressRegion: "IL", addressCountry: "US" },
      priceRange: "$$",
      ...(schema || {}),
    };
    let script = document.getElementById("ld-json");
    if (!script) { script = document.createElement("script"); script.id = "ld-json"; script.type = "application/ld+json"; document.head.appendChild(script); }
    script.textContent = JSON.stringify(ld);
  }, [title, description, schema]);
  return null;
};

export default Seo;
